import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { BuilderSections } from '../../util/builder';
import { AboutTreetPages } from '../../types/shopConfig/shopConfigV2';

const mansurgavrielSizes: string[] = [
  'One Size - Bag',
  'S',
  'M',
  'L',
  'IT 35',
  'IT 35.5',
  'IT 36',
  'IT 36.5',
  'IT 37',
  'IT 37.5',
  'IT 38',
  'IT 38.5',
  'IT 39',
  'IT 39.5',
  'IT 40',
  'IT 40.5',
  'IT 41',
  'IT 41.5',
  'IT 42',
  'IT 42.5',
  'IT 43',
  'IT 44',
  'IT 45',
  'IT 46',
];

const mansurgavrielConditionsOptions = [
  {
    key: Conditions.NewWithTags,
    label: 'New With Tags',
    shortLabel: 'New with Tags',
    description:
      'Your item has never been used and the original hanging tags are still on. For this option, you’ll need to take pictures of the retail tags.',
  },
  {
    key: Conditions.NewWithoutTags,
    label: 'Excellent',
    shortLabel: 'Excellent',
    description:
      'Your item has never been used, but the tags have been removed. There are no quirks or issues whatsoever.',
  },
  {
    key: Conditions.Excellent,
    label: 'Good',
    shortLabel: 'Good',
    description:
      'Your item has only been lightly used and has been extremely well maintained. There may be some small signs of wear, but nothing major.',
  },
  {
    key: Conditions.Good,
    label: 'Well Worn',
    shortLabel: 'Well Worn',
    description:
      'You’ve used this item and it’s well maintained. There may be some quirks like a small stain, or a loose thread, but it’s overall in good shape. You will need to take pictures of any quirks the item has.',
  },
];

export const mansurgavrielShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({
      options: mansurgavrielConditionsOptions,
    }),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: mansurgavrielSizes,
    }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.AboutPageHeroContent]: '5dc761f1a27145049948b4823a29ecc8',
      [BuilderSections.AboutPageInfoTabContent]: '71b0b9af4dbd4cf5a73dd9b850121bfb',
      [BuilderSections.FooterContent]: '0cc68e737081412ab06e95c5e352f5a7',
      [BuilderSections.TopbarContent]: 'fb1a2003b71b4aa8af74de9349a7793b',
      [BuilderSections.LandingPageContent]: '5136acea65c249908c7cd0d71e1c4f3c',
    },
  },
  enabledAboutTreetPages: [AboutTreetPages.AboutTreet],
  bgColorForBgRemovedImages: '#ebebeb',
};
